// @flow
import React from 'react'
import './styles.scss'

type Props = {
  slideId: string,
  isMobile: boolean,
  imgMobile: string,
  imgDesktop: string,
  captionOpen: boolean,
  captionWasOpen: boolean,
  isSliding: string,
  caption: string,
  credits: string,
  toggleCaption: any
}

const iconCaption = require('./img/caption-toggle.svg')

export class PhotoSlide extends React.Component<Props, State> {
  render () {
    if (
      !this.props.captionOpen &&
      this.props.isSliding &&
      this.props.captionWasOpen
    ) {
      this.toggleClass = 'hide'
    } else if (!this.props.captionOpen) {
      this.toggleClass = 'show'
    } else if (this.props.captionOpen) {
      this.toggleClass = 'hide'
    }
    return (
      <>
        <div
          className='section photo-slide'
          id={this.props.slideId}
          style={{
            backgroundImage: `url(${
              this.props.isMobile ? this.props.imgMobile : this.props.imgDesktop
            })`
          }}
        >
          <div
            className='caption'
            style={{ opacity: this.props.captionOpen ? 1 : 0 }}
            onClick={() => {
              this.props.toggleCaption()
            }}
          >
            <div className='bg'>
              <div
                className={`closer`}
                style={{ backgroundImage: `url(${iconCaption})` }}
              />
            </div>
            <p>{this.props.caption}</p>
            <p className='credits'>
              <i>{this.props.credits}</i>
            </p>
          </div>
          <div className='icon-wrapper'>
            <div
              className={`caption-toggle ${this.toggleClass}`}
              // className={`caption-toggle ${this.props.captionOpen ? 'hide' : 'show'}${this.props.isSliding ? ' sliding' : ''}`}
              style={{ backgroundImage: `url(${iconCaption})` }}
              onClick={this.props.toggleCaption}
            >
              <div className='label'>Bildinfo</div>
            </div>
          </div>
        </div>
      </>
    )
  }
}
